<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/page/page/page.component.ts.PageComponent.html